// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Caml from "rescript/lib/es6/caml.js";
import * as React from "react";
import * as Data13 from "common/src/data/Data13.bs.js";
import * as AdLayout from "../app-core/AdLayout.bs.js";
import * as Belt_Array from "rescript/lib/es6/belt_Array.js";
import * as Translation from "common/src/bindings/Translation.bs.js";
import * as Belt_SortArray from "rescript/lib/es6/belt_SortArray.js";
import * as ContentSection from "common/src/ContentSection.bs.js";
import * as RitoDescription2 from "common/src/components/RitoDescription2.bs.js";

function AnomaliesPage$AnomalyCard(Props) {
  var id = Props.id;
  var t = Translation.useT(/* Common */0);
  return React.createElement(React.Fragment, undefined, React.createElement("div", {
                  className: "flex justify-between items-center gap-2"
                }, React.createElement("div", {
                      className: "font-montserrat font-medium pb-2"
                    }, t(id))), React.createElement("div", undefined, React.createElement("div", {
                      className: "text-sm leading-none font-montserrat font-medium text-white2 pb-2"
                    }, t(id + "_typ"))), React.createElement(RitoDescription2.make, {
                  desc: t(id + "_desc"),
                  className: "text-sm leading-tight"
                }));
}

var AnomalyCard = {
  make: AnomaliesPage$AnomalyCard
};

function make(param) {
  var t = Translation.useT(/* Common */0);
  var anomalyIds = Belt_SortArray.stableSortBy(Object.keys(Data13.anomalies), (function (a1, a2) {
          return Caml.caml_string_compare(t(a1), t(a2));
        }));
  return React.createElement(AdLayout.make, {
              children: React.createElement("div", {
                    className: "grid grid-cols-3 gap-6 rounded md:w-[900px] pb-4 px-4 py-2 mt-8"
                  }, Belt_Array.map(anomalyIds, (function (id) {
                          return React.createElement(ContentSection.make, {
                                      className: "pt-4 pb-3",
                                      children: React.createElement(AnomaliesPage$AnomalyCard, {
                                            id: id
                                          })
                                    });
                        })))
            });
}

export {
  AnomalyCard ,
  make ,
  
}
/* react Not a pure module */
